import $axios from "../../../core/rest/axios";
export default class VoteService {
    vote(navrhId, data) {
        return $axios.post("/servlet/proxy/enavrhy/navrhy/" + navrhId + "/podporit", data);
    }
    canVote() {
        return $axios.get("/rest/users/permissions/navrhy/vote");
    }
}
